import { render } from "./ConfirmLogout.vue?vue&type=template&id=4fba7a23&scoped=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=4fba7a23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fba7a23"]])

export default __exports__